const API_URL = 'https://api.suitechannels.com';
// const API_URL = 'http://localhost:8080';
const ACCOUNT = window.__DEV__ ? 'sfcellsandbox' : 'sfcell'; // TODO offload to something else

export const getProducts = async () => {
  const res = await fetch(`${API_URL}/${ACCOUNT}/products`, {
    headers: { 'Content-Type': 'application/json' }
  });
  return res.json();
};

export const getOrders = async channelId => {
  const res = await fetch(
    `${API_URL}/${ACCOUNT}/orders?subscriptionId=${channelId}`,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return res.json();
};

export const saveProduct = async body => {
  const res = await fetch(`${API_URL}/${ACCOUNT}/products/${body.sku}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  return res.json();
};

export const saveProducts = async body => {
  const res = await fetch(`${API_URL}/${ACCOUNT}/products/bulkedit`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  return res.json();
};

export const uploadImageAction = sku => {
  return `${API_URL}/${ACCOUNT}/products/${sku}/image`;
};

export const getChannels = async () => {
  const res = await fetch(`${API_URL}/${ACCOUNT}/list`);
  return res.json();
};

export const listItems = async (id, skus) => {
  const res = await fetch(`${API_URL}/${ACCOUNT}/list`, {
    method: 'POST',
    body: JSON.stringify({ id, skus })
  });
  return res.json();
};

export const unlistItems = async (id, skus) => {
  const res = await fetch(`${API_URL}/${ACCOUNT}/list`, {
    method: 'DELETE',
    body: JSON.stringify({ id, skus })
  });
  return res.json();
};

export const getSettings = async () => {
  const res = await fetch(`${API_URL}/${ACCOUNT}/list/settings`);
  return res.json();
};

export const saveListingSettings = async (subId, settingId, themeId, skus) => {
  const res = await fetch(`${API_URL}/${ACCOUNT}/list/settings`, {
    method: 'PUT',
    body: JSON.stringify({
      subscriptionId: subId,
      listingSettingId: settingId,
      listingThemeId: themeId,
      skus
    })
  });
  return res.json();
};
